import React from 'react';
import styled from 'styled-components';

const FullscreenButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.7;
    }

    svg {
        width: 35px;
        aspect-ratio: 1 / 1;
        fill: ${props => props.theme.colors.white};
    }
`;

interface FullscreenIconProps {
    isFullscreen: boolean;
}

const FullscreenIcon: React.FC<FullscreenIconProps> = ({ isFullscreen }) => {
    if (isFullscreen) {
        return (
            <svg viewBox="0 0 24 24">
                <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
            </svg>
        );
    } else {
        return (
            <svg viewBox="0 0 24 24">
                <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
            </svg>
        );
    }
};

interface FullscreenToggleButtonProps {
    className?: string;
}

const FullscreenToggleButton: React.FC<FullscreenToggleButtonProps> = ({ className }) => {
    const [isFullscreen, setIsFullscreen] = React.useState(false);

    React.useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);

    const openInNewTab = () => {
        window.open('https://ksb-innovation-city-live.pluspol-networks.de/')
    }

    const toggleFullscreen = async () => {
        try {
            if (isFullscreen) {
                await document.exitFullscreen();
            } else {
                if (!document.documentElement.requestFullscreen) {
                    openInNewTab();
                } else {
                    await document.documentElement.requestFullscreen();
                }
            }
        } catch (error) {
            openInNewTab();
        }
    };

    return (
        <FullscreenButton
            className={className}
            onClick={toggleFullscreen}
            title={isFullscreen ? 'Vollbild verlassen' : 'Vollbild aktivieren'}
        >
            <FullscreenIcon isFullscreen={isFullscreen} />
        </FullscreenButton>
    );
};

export default FullscreenToggleButton;